import { Api } from '@/core/api.js';
const api = new Api();

// initial state
const state = {
    list: {},
    pages: {},
}

// getters
const getters = {

    getList: (state, getters, rootState) => (type) => {
        return state.list;
    },

    get_by_id: (state, getters, rootState) => (id) => {
        if (typeof state.list[id] !== 'undefined') {
            var document = { ...state.list[id] }
            if (document.tags) {
                var tags = document.tags;
                document.tags = tags.split(',');
            }
            if (document.pages) {
                var pages = document.pages;
                document.pages = pages.concat();
            }

            return document;
        }
        return false;
    },
    getPages: (state, getters, rootState) => (type) => {
        var pages = [];

        for (const key in state.pages) {
            var page = { ...state.pages[key] }
            pages.push(page)
        }
        return pages;
    },
    getPages_document: (state, getters, rootState) => (type) => {
        return state.pages;
    }


}

// actions
const actions = {

    loadList({ commit }, event_id) {
        var path = `document/all/${event_id}`;
        return api.get(path).then(function (response) {
            if (response.status) {
                var data = response.data;
                return commit('setList', data);
            } else {
                commit('setList', {})
            }
        });
    },
    loadPages({ commit }) {
        var path = `document/pages`;
        return api.get(path).then(function (response) {
            if (response.status) {
                var data = response.data;
                return commit('setPages', data);
            }
        });
    },
    load_by_id({ commit }, params) {
        var path = 'document/id/' + params.id;
        return api.get(path).then(function (response) {
            if (response.status) {
                var data = response.data;
                data.visible = true;
                return commit('addDocument', data);
            }
        });
    },

    deleteDocument(context, document) {
        var path = `document/${document.id}/delete`;
        return api.get(path).then(function (response) {
            return context.dispatch('loadList', document.event).then(function () { });
        });
    },
    upload(context, data) {
        var document = { ...data.data };
        document.event = (data.event) ? data.event.id : null;
        let form = new FormData();
        form.append('file', document.file)
        form.append('name', document.name)
        form.append('event_id', document.event)
        document.pages = document.pages ? document.pages : null;
        if (document.pages) {
            var array = [];
            document.pages.forEach(page => {
                if (page != -1) array.push(page);
            });
            document.pages = array;
        }
        form.append('pages', document.pages)
        document.tags = document.tags ? document.tags : "";
        form.append('tags', document.tags)
        var path = (typeof document.id !== 'undefined') ? `document/${document.id}/update` : 'document/add';
        return api.import(path, form).then(function (response) {
            if (response.status) {
                context.dispatch('loadList', document.event).then(function () { });
                return true;
            }
            else {
                return false;
            }
        });
    },




}

// mutations
const mutations = {
    setList(state, data) {
        for (const key in data) {
            data[key].visible = true;
        }
        state.list = data;
    },
    setPages(state, data) {
        state.pages = data;
    },
    addDocument(state, document) {
        var list = { ...state.list };
        list[document.id] = document;
        list[document.id].visible = true;
        state.list = list;
    },
    applyFilters(state, filters) {
        //var input = this.search;
        var filter = filters.search.toUpperCase();
        var cDocuments = { ...state.list };
        if (filters.search || filters.chips.length) {
            for (const key in cDocuments) {
                cDocuments[key].visible = false;
                if (filter) {
                    if (cDocuments[key].name.toUpperCase().indexOf(filter) > -1) {
                        cDocuments[key].visible = true;
                    }
                }
                if (filters.chips.length) {
                    cDocuments[key].visible = false;
                    filters.chips.forEach(chip => {
                        cDocuments[key].visible = cDocuments[key].tags.includes(chip);
                    });
                }
            }
        } else {
            for (const key in cDocuments) {
                cDocuments[key].visible = true;
            }
        }
        state.list = cDocuments;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}